/**
 * Created by ws7 on 2017/3/20.
 */


import * as commonConst from '../common/constants';
import * as diskConst from './constants';
import * as diskApis from '../../services/apis/disk';
import Axios from 'axios';
import _ from 'lodash';


export default {
    [diskConst.getDisks](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, diskApis.DescribeLocalVolumes);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(diskConst.getDisks, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [diskConst.validLocalImageSupport](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, diskApis.validLocalImageSupport);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [diskConst.describeEbsVolumes](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, diskApis.DescribeEbsVolumes);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(diskConst.describeEbsVolumes, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [diskConst.getDisksAllNum](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, diskApis.DescribeLocalVolumes);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(diskConst.getDisksAllNum, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [diskConst.getDisksSilence](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, diskApis.DescribeLocalVolumes);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [diskConst.deleteDisks](ctx,params) {
        return new Promise((resolve,reject) => {
            // params = _.merge(params, diskApis.DeleteLocalVolumeSnapshot);
            // ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
            //     resolve(data);
            // }).catch(e => {
            //     reject(e);
            // })
        });
    },
    [diskConst.createLocalSnap](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, diskApis.createLocalSnap);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [diskConst.getLocalSnapLists](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, diskApis.getLocalSnapLists);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(data.status == 200) {
                    resolve(data)
                } else {
                    reject(data);
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [diskConst.diskMonitor](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, diskApis.diskMonitor);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [diskConst.monitorScreen](ctx, params) {
        return new Promise((resolve, reject) => {
            params.params = _.merge(params.params, diskApis.monitorScreen.params);
            Axios.get('/newmonitorapi', params).then(data => {
                // 处理成功的响应
                console.log(data);
                resolve(data.data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [diskConst.metricsData](ctx, params) {
        return new Promise((resolve, reject) => {
            params.params = _.merge(params.params, diskApis.metricsData.params);
            Axios.post(`/newmonitorapi?Action=${params.params.Action}&Version=${params.params.Version}`, params.data, { headers: params.headers}).then(data => {
                // 处理成功的响应
                resolve(data.data);
            }).catch(e => {
                reject(e);
            });

            // params = _.merge(params, diskApis.metricsData);
            // ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
            //     resolve(data);
            // }).catch(e => {
            //     reject(e);
            // })
        });
    }
};

